<ng-container *ngIf="!isPageNotFound">
    <div class="not-found">
        <h2>Library Page</h2>
    </div>
</ng-container>
<ng-container *ngIf="isPageNotFound">
    <app-no-route></app-no-route>
</ng-container>